import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconAzureDevOps: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_134_1234)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14 11.1417V2.56665L10.5 3.20832V10.675L1.75 9.62498L5.30833 14V12.25L10.5 14L14 11.1417Z"
                            fill="currentColor"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.24167 1.45833V0L10.5 3.15L1.75 4.9V9.625L0 9.15833V5.19167L1.45833 3.325L6.24167 1.45833Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_134_1234">
                            <rect width="14" height="14" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 14.7333V4.93332L14 5.66665V14.2L4 13L8.06667 18V16L14 18L18 14.7333Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.13333 3.66667V2L14 5.6L4 7.6V13L2 12.4667V7.93333L3.66667 5.8L9.13333 3.66667Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21 17.325V6.29999L16.5 7.12499V16.725L5.25 15.375L9.825 21V18.75L16.5 21L21 17.325Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.025 4.875V3L16.5 7.05L5.25 9.3V15.375L3 14.775V9.675L4.875 7.275L11.025 4.875Z"
                        fill="currentColor"
                    />
                </svg>
            );
    }
};
